import { Component, OnInit, Output, EventEmitter, ElementRef, ViewChildren, ViewChild, AfterViewInit } from '@angular/core';
import { DigitalService } from 'src/app/core/services/digital.service';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { ToastrService } from 'ngx-toastr';
import { Message } from 'src/app/core/class/message';

@Component({
  selector: 'app-confirm-otp',
  templateUrl: './confirm-otp.component.html',
  styleUrls: ['./confirm-otp.component.scss']
})
export class ConfirmOtpComponent implements OnInit, AfterViewInit {
  isButtonConfirmCode: boolean = true;
  isButtonResendCode: boolean = false;
  valueOTP: any;
  overTimeConfirmation: boolean = false;
  isPhoneSended: string = '';

  resendConfirmationCodeModel = {
    phone: '',
    merchantCode: '',
    orderCode: ''
  }

  //count down
  counter: number = 100; //thời gian đến ngược.
  interval: number = 900; //khoảng thời gian chạy.
  valueCounter: number = 0; //value nhận được sau mỗi một khoảng thời gian.

  @ViewChild('focusFirstElement', { static: false }) focusFirstElement: ElementRef<any>;

  constructor(
    private digitalService: DigitalService,
    private router: Router,
    private spinnerService: Ng4LoadingSpinnerService,
    private toastr: ToastrService,
    private message: Message,
  ) {
  }

  ngOnInit() {
    const modelSaveOrder = JSON.parse(localStorage.getItem('modelSaveOrder'));
    if (modelSaveOrder !== null && modelSaveOrder !== undefined) {
      this.isPhoneSended = modelSaveOrder.phone;
    }
  }

  ngAfterViewInit() {
    this.focusFirstElement.nativeElement.focus();
  }

  onChangeVerification() {
    this.isButtonConfirmCode = true;
  }

  confirmOtp() {
    this.spinnerService.show();
    this.valueOTP ? this.isButtonConfirmCode = false : this.isButtonConfirmCode = true;
    const modelSaveOrder = JSON.parse(localStorage.getItem('modelSaveOrder'));
    modelSaveOrder.otp = this.valueOTP;
    this.digitalService.confirmOTP(modelSaveOrder).subscribe(rs => {
      if (rs !== null && rs !== undefined) {
        this.spinnerService.hide();
        this.toastr.success(this.message.getMessage('messages.authentication_successful'));
        this.goToItems();
      } else {
        this.toastr.warning(this.message.getMessage('messages.authentication_failed'));
      }
    }, (error) => {
      console.log(error);
      this.toastr.error(this.message.getMessage('messages.expired_date_order'));
    });
  }

  goToItems() {
    setTimeout(() => {
      this.router.navigate(['/digital/detail-order']);
    }, 2000);

  }

  resendConfirmationCode() {
    this.spinnerService.show();
    const model = JSON.parse(localStorage.getItem('modelSaveOrder'));
    if (model !== null && model !== undefined) {
      this.resendConfirmationCodeModel.phone = model.phone;
      this.resendConfirmationCodeModel.merchantCode = "SCONTRACT";
      this.resendConfirmationCodeModel.orderCode = model.orderCode;

      //call service.
      this.digitalService.resendConfirmationCode(this.resendConfirmationCodeModel).subscribe(rs => {
        if (rs != '' && rs != null) {
          this.spinnerService.hide();
          this.toastr.success(this.message.getMessage('messages.having_sent_back_otp'));
          const response = JSON.parse(rs);
          // console.log(response);
          this.isButtonResendCode = false;
        }
      }, (error) => {
        console.log(error);
        this.toastr.error(this.message.getMessage('messages.expired_date_order'));
      });

      setTimeout(() => {
        this.isButtonResendCode = true;
      }, 6000);
    }

  }

  getValueCounterInterval(event) {
    this.valueCounter = event;
    if (this.valueCounter === 0) {
      this.overTimeConfirmation = true;
      this.isButtonResendCode = true;
      this.isButtonConfirmCode = false;
    }
  }

}
